<template>
  <BaseCard title="Total Price" :edit="false">
    <v-container>
      <div v-if="isLoading">
        <v-progress-linear indeterminate></v-progress-linear>
      </div>
      <div v-else>
        <template v-if="!isBulk">
          {{ "$" + totalPrice?.toFixed(2) }}
        </template>
        <template v-else>
          <div>Sample Price: {{ "$" + totalPrice?.toFixed(2) }}</div>
          <div>Number of Samples: {{ numberOfSamples }}</div>
          <div>Total Price: {{ totalBulkPrice }}</div>
        </template>
      </div>
      <br />
      <small>Total price does not include shipping charges.</small>
    </v-container>
  </BaseCard>
</template>

<script>
import BaseCard from "@/components/samples/ReviewStepCards/BaseCard";
import { mapFields } from "vuex-map-fields";
import { mapActions, mapState } from "vuex";
export default {
  name: "Price",
  components: { BaseCard },
  data: () => ({
    isLoading: true
  }),
  computed: {
    ...mapState("samples", ["active_sample"]),
    ...mapFields("samples", ["active_sample"]),
    ...mapFields("sampleWizard", [
      "wizard.isBulk",
      "wizard.sampleIds",
      "wizard.barcode_start",
      "wizard.barcode_end",
      "wizard.lab_id_start",
      "wizard.lab_id_end"
    ]),
    totalPrice() {
      return this.active_sample.base_list_price;
    },
    numberOfSamples() {
      return this.sampleIds.length;
    },
    totalBulkPrice() {
      return this.numberOfSamples * this.totalPrice?.toFixed(2);
    }
  },
  methods: {
    ...mapActions("samples", ["getSamples", "setActive"])
  },
  async mounted() {
    this.isLoading = true;
    if (!this.isBulk) await this.getSamples(this.active_sample.id);
    else {
      Promise.all([
        this.setActive(this.sampleIds[this.sampleIds.length - 1])
      ]).then(data => {
        if (data.includes(false)) {
          this.error.message = "An error occurred while retrieving this sample";
        } else {
          this.lab_id_end = this.active_sample.slug;
        }
      });
    }
    this.isLoading = false;
  }
};
</script>

<style scoped></style>
